// firebase.js - DEPRECATED
// Firebase has been replaced by Supabase
// This file exists only to prevent build errors in legacy code

// ⚠️ WARNING: These are dummy exports and will not work
// Please migrate to Supabase (see supabase.js)

export const db = null;
export const auth = null;
export const storage = null;

// Log warning when this file is imported
if (process.env.NODE_ENV === 'development') {
  console.warn('⚠️ firebase.js is deprecated. Please use Supabase instead (see supabase.js)');
}